import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wancheng1",
  "use": "icon-wancheng1-usage",
  "viewBox": "0 0 1477 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1477 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-wancheng1\"><path d=\"M1454.010904 22.018534a78.308592 78.308592 0 0 0-110.553306 1.750427L553.185713 835.138102 136.399748 433.8296A78.216464 78.216464 0 1 0 27.412614 546.041206l472.891767 455.848133a78.216464 78.216464 0 0 0 110.553307-1.566172l844.719388-867.659199a78.216464 78.216464 0 0 0-1.750427-110.553307z m0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wancheng1.svg
// module id = FfvL
// module chunks = 16